import React from 'react';
import PropTypes from 'prop-types';
import Youtube from 'react-youtube';
import Media from 'react-media';

const Tools = ({ title, contentHTML, videoId }) => {
  const optsBig = {
    height: '400',
    width: '100%',
  };

  const optsSmall = {
    height: '250',
    width: '100%',
  };

  return (
    <div style={{ padding: '30px 0 30px 0' }}>
      <center>
        <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
      </center>
      <div className="row">
        <div className="col-md-6">
          <Media query={{ minWidth: 768 }}>
            {matches =>
              matches ? (
                <Youtube videoId={videoId} opts={optsBig} />
              ) : (
                <Youtube videoId={videoId} opts={optsSmall} />
              )
            }
          </Media>
        </div>
        <div className="col-md-6">
          <div
            style={{
              padding: '0 15px 0 15px',
              fontFamily: 'Roboto',
              fontSize: 18,
              textAlign: 'justify',
              color: '#787878',
            }}
            dangerouslySetInnerHTML={{ __html: contentHTML }}
          />
        </div>
      </div>
    </div>
  );
};

Tools.propTypes = {
  title: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Main/about/Tools.js